import React, { Component } from 'react';
import '../settings.css';
import TagsByInput from '../../TagsAndChips/TagsByInput';
import { showNotification } from '../../../StatusNotification';

export class BirthdaySettings extends Component {
    static displayName = BirthdaySettings.name;

    constructor(props) {
        super(props);
        this.state = {
            birthdayConfigurations: null,
            removedTags: []
        };
        this.onTypeTagRemoval = this.onTypeTagRemoval.bind(this);
    }

    componentDidMount() {
        this.getComponentData();
    }

    handleChange = (e) => {
        let newBirthdayConfigurations = this.state.birthdayConfigurations;
        newBirthdayConfigurations[e.target.name] = e.target.value;
        this.setState({ birthdayConfigurations: newBirthdayConfigurations });
    }

    handleSubmit = (e) => {
        e.preventDefault();

        let birthdayConfigurations = this.state.birthdayConfigurations;

        fetch('AdminSettings/UpdateBirthdaySettingsData', {
            method: 'POST',
            body: JSON.stringify(birthdayConfigurations),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then(
            response => response.json()
        ).then(
            data => {
                if (data === "Saved") {
                    if (this.state.removedTags.length > 0) {
                        let removedTags = this.state.removedTags;
                        for (var i = 0; i < removedTags.length; i++) {
                            let tag = removedTags[i];
                            fetch('AdminBirthday/RemoveBirthdayTypeReference?typeToRemove=' + tag, {
                                method: 'GET',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                }
                            });
                        }
                    }

                    this.props.onComponentSaved();
                }
                else {
                    showNotification(data, "error");
                }
            }
        )
    }

    async onTypeTagRemoval(tag) {
        let removedTags = this.state.removedTags;
        removedTags.push(tag);
        this.setState({ removedTags: removedTags });
    }

    render() {
        let types;

        let isBirthdayConfigurationsSet = false;
        if (this.state.birthdayConfigurations != null) {
            let birthdayConfigurations = this.state.birthdayConfigurations;
            types = birthdayConfigurations.types;

            isBirthdayConfigurationsSet = true;
        }

        let typesInput = isBirthdayConfigurationsSet ?
            <TagsByInput
                tags={types}
                tagUpdate={this.handleChange}
                name='types'
                isRequired={true}
                allowDuplicates={false}
                inputType='text'
                onTagRemoval={this.onTypeTagRemoval}
            /> : "";

        return (
            <div className='admin-settings--form'>
                <form onSubmit={this.handleSubmit}>
                    <div className='grid-wrapper'>
                        <div className='dual-grid--offset'>
                            <div className='dual-grid__1-2 form-title'>
                                <h3>Birthday</h3>
                            </div>

                            <label>Departments: </label>
                            {typesInput}

                            <div className='dual-grid__1-2'>
                                <button type='submit' className='form-button'>Save</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }

    async getComponentData() {
        const response = await fetch('AdminSettings/GetBirthdaySettingsData', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        this.setState({
            birthdayConfigurations: data
        });
    }
}

export default BirthdaySettings;